import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from '../index.module.scss'

export const Title = () => {
  return (
    <>
      <div className={classes.title}>
        <Element
          elementName="p"
          style={{
            fontSize: 24,
            color: '#0553A5',
            textTransform: 'uppercase',
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          <Translate value="library.main.FILTERED_COMPANIES" />
        </Element>
      </div>
    </>
  )
}
